import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";

import PeriodSelect from "@/modules/recognition/user/components/dashboard/PeriodSelect";
import TopPage from "@/modules/recognition/user/components/top-employees/TopPage";
import { fetchPeriodQueryOptions } from "@/modules/recognition/user/services";

export const Route = createFileRoute(
  "/_panel/_recognition/recognition/top/$id",
)({
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) => {
    return {
      crumb: [
        {
          label: context.t("Top Employees", { ns: "recognition.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchPeriodQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  component: Component,
});

function Component() {
  const { t } = useTranslation("recognition.user");
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();
  return (
    <Container
      title={t("Top Employees", { ns: "recognition.shared" })}
      description={t("View the top employees of each appreciation period")}
      action={
        <PeriodSelect
          value={id}
          onChange={(value) => {
            if (value) {
              navigate({
                to: "/recognition/top/$id",
                params: { id: value },
              });
            }
          }}
        />
      }
    >
      <TopPage id={id} />
    </Container>
  );
}
